import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  Button,
  Spinner,
  DownloadButtonWithSelection,
} from '../../../../components';
import { ScrapingStatus } from '../const';
import type { FileTypes } from '../../../../services/scraper';

type ScrapingActionsProps = {
  status: string | null;
  onRetry: () => void;
  onDownload: (fileType: FileTypes) => void;
  onViewErrors: () => void;
  onDelete?: () => void;
  downloading?: boolean;
  error?: string | null;
};

const ScrapingActions: React.FC<ScrapingActionsProps> = ({
  status,
  onRetry,
  onDownload,
  onViewErrors,
  onDelete,
  downloading = false,
}) => {
  switch (status) {
    case ScrapingStatus.SUBMITTED:
    case ScrapingStatus.PENDING:
    case ScrapingStatus.IN_PROCESS:
    case ScrapingStatus.STARTED:
    case ScrapingStatus.IN_PROCESS_PARSING:
    case ScrapingStatus.IN_PROCESS_KNOWLEDGE:
    case ScrapingStatus.IN_PROCESS_DEMO:
      return (
        <div className="flex items-center gap-2">
          <Spinner className="h-10 w-10" />
          <Button
            onClick={onDelete}
            size="small"
            className="px-2"
            type="contrast"
            icon={<DeleteIcon className="h-6 w-6 text-buttonPrimary" />}
          />
        </div>
      );

    case ScrapingStatus.SUCCESS:
    case ScrapingStatus.SUCCESS_PARSING:
    case ScrapingStatus.SUCCESS_KNOWLEDGE:
    case ScrapingStatus.SUCCESS_DEMO:
      return (
        <div className="flex gap-2">
          <DownloadButtonWithSelection
            onDownload={onDownload}
            downloading={downloading}
          />
          {onDelete && (
            <Button
              onClick={onDelete}
              size="small"
              className="px-2"
              type="contrast"
              icon={<DeleteIcon className="h-6 w-6 text-buttonPrimary" />}
            />
          )}
        </div>
      );

    case ScrapingStatus.FAILURE:
    case ScrapingStatus.FAILURE_PARSING:
    case ScrapingStatus.FAILURE_KNOWLEDGE:
    case ScrapingStatus.FAILURE_DEMO:
      return (
        <div className="flex gap-2">
          <Button
            label="Errors"
            onClick={onViewErrors}
            size="small"
            type="contrast"
            className="px-4"
          />
          <Button
            label="Retry"
            onClick={onRetry}
            size="small"
            className="px-4"
          />
          {onDelete && (
            <Button
              onClick={onDelete}
              size="small"
              className="px-2"
              type="contrast"
              icon={<DeleteIcon className="h-6 w-6 text-buttonPrimary" />}
            />
          )}
        </div>
      );

    case ScrapingStatus.REVOKED:
      return (
        <div className="flex gap-2">
          {onDelete && (
            <Button
              onClick={onDelete}
              size="small"
              className="px-2"
              type="contrast"
              icon={<DeleteIcon className="h-6 w-6 text-buttonPrimary" />}
            />
          )}
        </div>
      );

    case ScrapingStatus.UNKNOWN:
    default:
      return null;
  }
};

export default ScrapingActions;
